import { cx } from "@suse-o11y/class-variance";
import React from "react";

const DialogPortal = React.lazy(async () => {
	const Dialog = await import("@radix-ui/react-dialog");

	return { default: Dialog.Portal };
});

const DialogContent = React.lazy(async () => {
	const Dialog = await import("@radix-ui/react-dialog");

	return { default: Dialog.Content };
});

const DialogOverlay = React.lazy(async () => {
	const Dialog = await import("@radix-ui/react-dialog");

	return { default: Dialog.Overlay };
});

export type DialogProps = Omit<React.ComponentPropsWithoutRef<typeof DialogContent>, "forceMount">;

export const Dialog = React.forwardRef<React.ComponentRef<typeof DialogContent>, DialogProps>(
	({ className, ...props }, ref) => (
		<React.Suspense>
			{/*
        Put the consumer className on the overlay wrapper so the visible backdrop (its `> *` child)
        inherits z-index/animation via the `dialog-overlay` variant, while `display: contents`
        keeps the wrapper itself visually inert.
      */}
			<DialogPortal>
				<DialogOverlay className={cx("suse-o11y/dialog-overlay", className)} style={{ display: "contents" }}>
					{/* Visible backdrop; styled via `dialog-overlay:` variant on the wrapper. */}
					<div />
				</DialogOverlay>

				<DialogContent {...props} className={cx("suse-o11y/dialog", className)} ref={ref} />
			</DialogPortal>
		</React.Suspense>
	),
);

Dialog.displayName = "Dialog";
